import { createApp } from 'vue'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import App from './App.vue'
import router from './router'
import { setUnauthorizedHandler } from './services/apiClient'
import { useAuthStore } from './stores/useAuthStore'
import './assets/main.css'

const app = createApp(App)

const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)

app.use(pinia)
app.use(router)

// Global 401 handler: backend rejected session → logout + redirect to /login
// Registered before mount so the very first API call is covered.
setUnauthorizedHandler(() => {
  const authStore = useAuthStore()
  if (!authStore.user && !authStore.session) return
  authStore.logout()
  router.push({ name: 'login', query: { expired: '1' } }).catch(() => {})
})

app.mount('#app')
